module.exports = __webpack_public_path__ + "static/media/24hOURS.57a1727f.svg";